import { apiClient, handleResp } from './utils';

export default {
  getStoryVideos(slug) {
    return handleResp(apiClient().get('/intro_videos/primary_story_videos?slug=' + slug));
  },
  create(payload) {
    return handleResp(apiClient().post('/intro_videos', payload));
  },
  delete(payload) {
    return handleResp(apiClient().delete('/intro_videos/' + payload.id));
  },
  fetch(type) {
    return handleResp(apiClient().get('/intro_videos/fetch?type=' + type));
  },
  getSlug(type) {
    return handleResp(apiClient().get('/intro_videos/get_slug?type=' + type));
  },
  checkSlug(type, slug) {
    return handleResp(apiClient().get(`/intro_videos/check_slug_validity?type=${type}&slug=${slug}`));
  },
  saveSlug(type, slug) {
    return handleResp(apiClient().post('/intro_videos/save_slug', { type, slug }));
  },
};
